class InlineCompletionsAccessibleView {
}

export { InlineCompletionsAccessibleView };
